import { useContext, useEffect } from 'react';
import { matchRoutes } from 'react-router-dom';
import PermissionContext from './PermissionContext';
import { useLocalObservable } from 'mobx-react-lite';
import { cloneDeep, isNil } from 'lodash-es';
// import routes from '@/config/routes';
// import { includes } from 'lodash-es';

type PermissionApi = {
  hasPageElementPermission: Function,
  hasRoutePermission: Function,
}

function usePermission(): PermissionApi {
  const { pageElementPermission, routePermission, isChildAccount } = useContext(PermissionContext);
  const store = useLocalObservable(() => ({
    routePermission: routePermission,
    pageElementPermission: pageElementPermission,
    isChildAccount: isChildAccount,
    setConfig(params: any) {
      this.routePermission = params.routePermission;
      this.pageElementPermission = params.pageElementPermission;
      this.isChildAccount = params.isChildAccount;
    },
    hasPageElementPermission(needPermission: string) {
      return !this.isChildAccount || (this.pageElementPermission || []).some(d => d == needPermission);
    },
    hasRoutePermission(path: string = '') {
      const match = matchRoutes(this.routePermission?? [], path);
      return !isNil(match);
    },
  }));
  useEffect(() => {
    store.setConfig(cloneDeep({
      routePermission,
      pageElementPermission,
      isChildAccount,
    }));
  }, [routePermission, pageElementPermission, isChildAccount]);
  return store;
}


export default usePermission;
